import { motion } from "framer-motion";
import Checkbox from "components/checkbox";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import api from "utils/api";

export default function SignIn() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    setError("");
    setLoading(true);
    try {
      const response = await api.post("/sign_in", { email, password });
      const data = response.data;


      // Only allow SA, A, R roles into the admin portal
      if (!["SA", "A", "R"].includes(data.role)) {
        setError("Access denied. This portal is for admins and runners only.");
        return;
      }

      login(data);
      navigate("/admin/default");
    } catch (err) {
      if (err.response && err.response.data) {
        const d = err.response.data.detail;
        const msg = typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg || JSON.stringify(x)).join(" ") : (d?.msg || JSON.stringify(d));
        setError(msg || "Invalid request. Please try again.");
      } else {
        setError("An error occurred during sign in. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen w-full">
      {/* LEFT SECTION */}
      <motion.div
        initial={{ x: -120, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        className="relative hidden w-1/2 flex-col items-center justify-center
          bg-gradient-to-br from-[#F0F9FF] via-[#E0F2FE] to-[#7DD3FC] px-10 lg:flex"
      >
        <motion.img
          src="/cloud_iron.webp"
          alt="Laundry Management"
          className="mb-4 w-full max-w-[300px]"
        />
        <p className="text-center text-lg font-semibold text-navy-700 dark:text-white">
          Admin Dashboard - Cloud Ironing Simplified
        </p>
      </motion.div>

      {/* RIGHT SECTION */}
      <motion.div
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="flex w-full items-center justify-center lg:w-1/2"
      >
        <form
          autoComplete="off"
          className="w-full max-w-[420px] px-6"
          onSubmit={(e) => e.preventDefault()}
        >
          <h4 className="mb-6 text-3xl font-semibold text-gray-800 dark:text-white">Sign In</h4>

          <div className="mb-4">
    <label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
      Email
    </label>
    <input
      type="email"
      placeholder="Enter your email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      className="w-full rounded-lg border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition-all duration-200 
      focus:border-brand-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-brand-200
      dark:border-navy-700 dark:bg-navy-800 dark:text-white dark:focus:border-brand-400 dark:focus:ring-brand-400/20"
    />
  </div>

          {/* Password */}
  <div className="mb-4">
    <label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
      Password
    </label>
    <input
      type="password"
      placeholder="Enter your password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      className="w-full rounded-lg border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 shadow-sm transition-all duration-200 
      focus:border-brand-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-brand-200
      dark:border-navy-700 dark:bg-navy-800 dark:text-white dark:focus:border-brand-400 dark:focus:ring-brand-400/20"
    />
  </div>

          {/* Keep Logged In */}
  <div className="mb-6 flex items-center justify-between">
    <div className="flex items-center">
      <Checkbox />
      <span className="ml-2 text-sm text-gray-600 dark:text-gray-300">
        Keep me signed in
      </span>
    </div>
  </div>
          <motion.button
    whileHover={{ scale: 1.02 }}
    whileTap={{ scale: 0.98 }}
    onClick={handleSignIn}
    disabled={loading}
    className={`w-full rounded-lg py-3 text-sm font-semibold text-white shadow-md transition-all duration-200 ${
      loading
        ? "cursor-not-allowed bg-gray-400"
        : "bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-300"
    }`}
  >
    {loading ? "Signing in..." : "Sign In"}
  </motion.button>


          {error && <p className="mt-3 text-sm text-red-500">{error}</p>}
        </form>
      </motion.div>
    </div>
  );
}
